module.exports = __webpack_public_path__ + "img/赞.2a7c64f3.svg";